import axios from 'axios';

// Tells the backend which portal page (menu) a request came from, for the user-activity log.
let currentPage = null;
let installed = false;

export const setPortalPage = (pathname) => {
  currentPage = pathname;
  axios.defaults.headers.common['X-Portal-Page'] = pathname;
};

export const installActivityTracker = () => {
  if (installed || typeof window === 'undefined') return;
  installed = true;
  const nativeFetch = window.fetch.bind(window);
  window.fetch = (input, init = {}) => {
    try {
      const url = typeof input === 'string' ? input : input?.url || '';
      if (currentPage && url.includes('/api/')) {
        const headers = new Headers(init.headers || (typeof input !== 'string' ? input.headers : undefined) || {});
        headers.set('X-Portal-Page', currentPage);
        return nativeFetch(input, { ...init, headers });
      }
    } catch (e) {
      // fall through to the untouched request
    }
    return nativeFetch(input, init);
  };
};
